import React, { useEffect, useState } from 'react'
import { useVenti } from 'venti'
import { useNavigate } from 'react-router-dom'
import { ModalYesNo } from './ModalYesNo'
import { TheBigPOSApi } from '../../lib/TheBigPOSClient'
import { navigationLinking } from '../../services/navigation'
import { INITIAL_DRAFT_MODAL_CONFIRMATION } from '../../pages/protected/portal/constants'
import useUser from '../../hooks/useUser'
import { getTheme } from '../../config'
import { useAppContextActions } from '../AppContext/AppHooks'

const theme = getTheme()

const ModalLoanDraft = () => {
	const ventiState = useVenti()
	const { user } = useUser()
	const { applyUser } = useAppContextActions()
	const navigate = useNavigate()

	const [draftModalConfirmation, setDraftModalConfirmation] =
		useState(INITIAL_DRAFT_MODAL_CONFIRMATION)

	const appPosting = ventiState.get(theme.storageKeys.appPosting)

	const handleOpenDraft = async () => {
		try {
			setDraftModalConfirmation((current) => ({
				...current,
				open: false,
			}))
			const draft = await TheBigPOSApi.getLoanDraft(user.drafts[0].id)
			applyUser({ ...user, drafts: [] })
			ventiState.set(theme.storageKeys.loanDraft, draft.data)
			navigate(`/${navigationLinking.Apply}`)
		} catch {
			ventiState.set(theme.storageKeys.errorObject, {
				message:
					'There was a problem retrieving the saved application.',
			})
		}
	}

	const handleRemoveDraft = async () => {
		try {
			setDraftModalConfirmation((current) => ({
				...current,
				open: false,
			}))
			await TheBigPOSApi.deleteLoanDraft(user.drafts[0].id)
			applyUser({ ...user, drafts: [] })
		} catch {
			ventiState.set(theme.storageKeys.errorObject, {
				message:
					'There was a problem removing the saved application.',
			})
		}
	}

	useEffect(() => {
		if (user.isLoggedIn && user.drafts?.length > 0 && !appPosting) {
			setDraftModalConfirmation((current) => ({
				...current,
				open: true,
				text: 'You have an application in progress. Would you like to continue where you left off?',
			}))
		}
	}, [user.drafts?.length, user.isLoggedIn, appPosting])

	return (
		<ModalYesNo
			modalConfirmation={draftModalConfirmation}
			modalConfirm={handleOpenDraft}
			modalDismiss={handleRemoveDraft}
			setModalConfirmation={setDraftModalConfirmation}
		/>
	)
}

export default ModalLoanDraft
